import { useRef, useState, useEffect } from "react";
import onlCamImg from "../../../images/onl-cam.svg";
import offlCamImg from "../../../images/offl-cam.svg";
import loadingCamImg from "../../../images/camera-rotate.png";
import unplacedCamImg from "../../../images/unplaced_cam.svg";
import Cameras from './Cameras';
import NoImageAvailable from "./noImageAvailable/NoImageAvailable";
// import { Modal } from 'react-bootstrap';
// import CustomTooltipMapZoom from "../../tooltips/CustomTooltipMapZoom";
import { useDispatch, useSelector } from "react-redux";
import { listPlacedCamPositions } from '../../../redux/actions/listPlacedCamPositions';
import { canAccess } from '../../../config';
import './siteMapCustomStyle.css';

// Import generic components
import Button from "../../../generic_components/Button/Button";
import Input from "../../../generic_components/Input/Input";
import Modal from "../../../generic_components/Modal/Modal";
import Tooltip from "../../../generic_components/Tooltip/Tooltip";


const SaveConfig = (
    {
    canvascamImagesRef, 
    isUploaded,
    uploadedUrl,
    step,
    setStep,
    cameraPositions,
    totalCameras,
    filteredCameraList,
    handleSaveLayout,
    handleGoToCameraPlacement,
    searchItem,
    handleSearchItem,
    handleClearSearch,
    totalOnlineCams,
    hwid,
    userBusinessRole
}
) => {
    const draggingRef = useRef(null);
    const draggingSiteMapRef = useRef(false);
    const lastMouse = useRef({ x: 0, y: 0 });

    const canvasRef = useRef(null);
    const hoveringCamImg = useRef(null);
    const camImageWidth = 30;
    const camImageHeight = 30;
  
    const isSmallScreen = window.innerWidth < 600;
    const [configName, setConfigName] = useState('');
    const [isHovering, setIsHovering] = useState(false);
    const [totalPlacedCams, setTotalPlacedCams] = useState(0);
    // const [openGuidelinePopUp, setOpenGuidelinePopUp] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [selectedCameraName, setSelectedCameraName] = useState('');
    const [selectedImageUrl, setSelectedImageUrl] = useState(null); 
    const [selectedImageUpdateTime, setSelectedImageUpdateTime] = useState(null);

    // image loaded state
    const [imageLoaded, setImageLoaded] = useState(false);
    const [animate, setAnimate] = useState(false);

    // Zooming
    const [zoom, setZoom] = useState(1); // current zoom scale 100%
    const [pan, setPan] = useState({x:0, y:0});
    const MAX_ZOOM = 4; // Max scale 400%
    const MIN_ZOOM = 1; // Min scale 100%
    const ZOOM_STEP = 1; // Zoom by 100%

    const dispatch = useDispatch();

    // camera shapshot related
    const placedCameras = useSelector(state => state.placedCameras);

    // Handle image load event
    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    // Handle image load for animation
    useEffect(() => {
        if (imageLoaded) {
            // Delay slightly to ensure we see the blur effect
            const timer = setTimeout(() => setAnimate(true), 50);
            return () => clearTimeout(timer);
        } else {
            setAnimate(false);
        }
    }, [imageLoaded]);
    

    // Close the image render modal
    const closeModal = () => {
        setShowModal(false);
        setImageLoaded(false); // Reset states
        setAnimate(false);
        setIsCamClicked(false);
    };

    // console.log(`showModal is ${showModal}`);
    const [isCamClicked, setIsCamClicked] = useState(false);

    // Handle click on canvas
    const handleCanvasClick = (e) => {        
        if (draggingRef.current) {        
                return;
        }

        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;


        // console.log(`Line 113 the placedCameras is ${JSON.stringify(placedCameras, null, 2)}`)

        for (const placedCamera of cameraPositions) {
            const camX = placedCamera.x;
            const camY = placedCamera.y;
            const withinX = clickX >= camX && clickX <= camX + camImageWidth;
            const withinY = clickY >= camY && clickY <= camY + camImageHeight;

            if (withinX && withinY) {
                // const newImageUrl = placedCamera.monthly_image_url;
                const newImageUrl = placedCameras.find(cam => cam.camera_id === placedCamera.camera_id)?.monthly_image_url;
                const newCameraName = placedCamera.camera_name;

                if (selectedImageUrl !== newImageUrl || selectedCameraName !== newCameraName) {
                    setSelectedImageUrl(newImageUrl);
                    setSelectedCameraName(newCameraName);
                    setSelectedImageUpdateTime(placedCamera.monthly_image_update_time || null);
                }
                setIsCamClicked(true);
                setShowModal(true);
                break;
            }
        }
    };

    // Refetch the placed cams from db every time the cam icon is clicked.
    // useEffect(() => {
    //     if (!selectedCameraName) return;
    //     // console.log(`Line 131 the selected camera name is ${selectedCameraName}`);
    //     dispatch(listPlacedCamPositions(hwid));
    // },[dispatch, selectedCameraName, hwid]);

    useEffect(() => {
        if (!isCamClicked) return;
        // console.log(`Line 131 the selected camera name is ${selectedCameraName}`);
        dispatch(listPlacedCamPositions(hwid));
    },[dispatch, isCamClicked, hwid]);

    // useEffect(() => {
    //     console.log(`Line 154 isCamClicked is ${isCamClicked}`);
    // },[isCamClicked]);

    // Render the uploaded image
    useEffect(() => {
        const canvas = canvasRef.current;
               
        if (!isUploaded || !canvas || !uploadedUrl || step !== 2) return;

        if (canvas) {
            // console.log(`                                   RENDERING IMAGE from SaveConfig`);
            const img = new Image(); // image object
            img.crossOrigin = 'anonymous'; // Allow cross-origin from S3
            img.src = uploadedUrl;

            img.onload = () => {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height); // clear previous drawing
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.translate(pan.x, pan.y);
                ctx.scale(zoom, zoom);
                ctx.drawImage(img, 0, 0, canvas.width-40, canvas.height);
            }
            // Unable to load image
            img.onerror = (err) => {
                // setPreviewUploaded(null);
                console.warn('Uploaded Site Plan Image failed to load:', uploadedUrl)
            }
        }
    }, [isUploaded, uploadedUrl, step, zoom, pan]);


    const loadImage = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                resolve(img);
            }

            img.onerror = () => {
                reject(new Error(`Failed to load image: ${url}`)); // loading failed
            };

            img.src = url; // Start loading the image
        });
    };

    // Extract and format date part from timestamp string
    function getDatePart(timestamp) {
    try {
        if (typeof timestamp !== "string" || !timestamp.includes("T")) {
        throw new Error("Invalid timestamp format");
        }

        const datePart = timestamp.split("T")[0]; // "2025-11-05"

        if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
        throw new Error("Invalid date part");
        }

        // Convert to readable format: "Nov 5, 2025"
        const formattedDate = new Date(datePart).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        });

        return formattedDate; // e.g., "Nov 5, 2025"
    } catch (err) {
        console.error("getDatePart error:", err.message);
        return null;
    }
    }


    const utcStrToLocal = (utcTimestamp) => {
        // Create a Date object using the UTC timestamp
        const utcDate = new Date(utcTimestamp);
        // Get the local time components
        const localYear = utcDate.getFullYear();
        const localMonth = utcDate.getMonth() + 1; // Months are zero-based
        const localDay = utcDate.getDate();
        const localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes();
        const localSeconds = utcDate.getSeconds();
        // Create a new Date object with the local time components
        const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);
        // Format the local time as needed
        const formattedLocalTime = localDate.toLocaleString();
        return formattedLocalTime
    }

    // Remove cameras when there is no camera name or camera name is undefined. (For case when cam does not exist in CAMERAS_INFO table) 
    const sanitise_cam_list = (camPositions) => {
        const camsToRender = [];
        for (const cam of camPositions) {
            if (cam.camera_name) {
                camsToRender.push(cam);
            }
        }
        return camsToRender;
    }

    // Can render the cameras positions from db after. It's not expensive to redraw hundreds of images of size 30 x `30`. 
    useEffect(() => {
        
        const canvas = canvascamImagesRef.current; // Camera Icons Canvas Layer reference

        if (!canvas || cameraPositions.length === 0) return;

        // console.log(`                              RENDERING CAMERAS FROM SaveConfig ${JSON.stringify(cameraPositions, null, 2)}`);

        // Only include cameras when its camera_name exists. Remove cam when there is no camera_name or it is undefined.
        const camsToRender = sanitise_cam_list(cameraPositions);

        // console.log(`Line 241 the sanitised cam list is ${JSON.stringify(camsToRender, null, 2)}`);

        const dateTimeUTC = (datetime) => {
            let deviceOfflineSince = datetime;
            if (datetime !== null) {
                deviceOfflineSince = utcStrToLocal(datetime);
            }
            return deviceOfflineSince;
        };

        const ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.translate(pan.x, pan.y);
        ctx.scale(zoom, zoom);

        // Calculate number of placed cams
        setTotalPlacedCams(0);
        for (const cam of camsToRender){
            if (cam.placed){
                setTotalPlacedCams(prev => prev + 1);
            }
        }

        // Ensure all given images are fully loaded, then use them for rendering
        Promise.all([
            loadImage(onlCamImg),
            loadImage(offlCamImg),
            loadImage(loadingCamImg),
        ])
        .then(([onlineImg, offlineImg, loadingImg]) => {
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear previous drawing but wait for the camera image to load first for smooth transition 
            for (const placedCamera of camsToRender) {
                const img = placedCamera?.camera_status === 1 
                ? onlineImg
                : (placedCamera?.camera_status === 0 ? offlineImg: loadingImg);

                ctx.drawImage(img, placedCamera.x, placedCamera.y, camImageWidth, camImageHeight); // place image at drop position and resize it
                // Hover on camera image
                if (isHovering && placedCamera.camera_id === hoveringCamImg.current) {
                    const textMetrics = ctx.measureText(placedCamera.camera_name);
                    const textWidth = textMetrics.width;
                    const padding = 20;
                    let yShift = 13;
                    let xShift = 30;
                    // If x <= background width/2, put text to right
                    if(placedCamera.x <= (textWidth+padding)/2) {
                        // camera_name
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x+xShift, placedCamera.y, textWidth, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`, placedCamera.x+textWidth/2+xShift, placedCamera.y+yShift);

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x+xShift, placedCamera.y + 17, textWidth, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`, placedCamera.x+textWidth/2+xShift, placedCamera.y+yShift + 17);
                        }
                    }                    
                    // If x + background width/2 >= max width, put text to left
                    else if (placedCamera.x + (textWidth+padding)/2 >= canvas.width) {
                        // camera_name
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-textWidth, placedCamera.y, textWidth, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`, placedCamera.x-textWidth/2, placedCamera.y+yShift);

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-textWidth, placedCamera.y + 17, textWidth, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`, placedCamera.x-textWidth/2, placedCamera.y+yShift+17);
                        }
                    }
                    // If y + background height >= max height, put text to top 
                    else if (placedCamera.y + (padding + 30) >= canvas.height){    
                        // camera_name                    
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20, textWidth+padding, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y+yShift-20);

                        if (placedCamera.cameraOfflineSince) {
                            // camera_name                    
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20-17, textWidth+padding, padding);
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y+yShift-20-17);

                            // cameraOfflineSince
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20, textWidth+padding, padding);                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`,placedCamera.x, placedCamera.y+yShift-20);
                        }
                    }
                    // Camera icon is not near any of the edges
                    else {
                        // camera_name                      
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y + yShift + 17, textWidth+padding, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y + (yShift+30));

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y + yShift + 17 + 17, textWidth+padding, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`,placedCamera.x, placedCamera.y + (yShift+30) + 17);
                        }
                    }
                }
            }
        })
    }, [cameraPositions, isUploaded, isHovering, canvascamImagesRef, zoom, pan]);

    const handleConfigNameChange = (e) => {
        setConfigName(e.target.value);
    };

    const handleExportAsPNG = () => {
        const canvasSitePlan = canvasRef.current;
        const canvasCam = canvascamImagesRef.current;

        if (!canvasSitePlan || !canvasCam) return;

        // Create a temporary canvas
        const combinedCanvas = document.createElement("canvas");
        combinedCanvas.width = canvasSitePlan.width;
        combinedCanvas.height = canvasCam.height;
        const ctx = combinedCanvas.getContext("2d");

        // Draw the site plan first
        ctx.drawImage(canvasSitePlan, 0, 0);
        // Then draw the cameras on top
        ctx.drawImage(canvasCam, 0, 0);

        // Convert to PNG and download
        const dataURL = combinedCanvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = !configName ? 'site_plan.png' : `${configName}.png`;
        link.href = dataURL;
        link.click();
    };
     

    // const handleExportAsPDF = () => {
    //     const canvasSitePlan = canvasRef.current;
    //     const canvasCam = canvascamImagesRef.current;

    //     if (!canvasSitePlan || !canvasCam) return;

    //     // Create a temporary canvas
    //     const combinedCanvas = document.createElement("canvas");
    //     combinedCanvas.width = canvasSitePlan.width;
    //     combinedCanvas.height = canvasCam.height;
    //     const ctx = combinedCanvas.getContext("2d");

    //     // Draw the site plan first
    //     ctx.drawImage(canvasSitePlan, 0, 0);
    //     // Then draw the cameras on top
    //     ctx.drawImage(canvasCam, 0, 0);

    //     // Convert to PNG and download
    //     const dataURL = combinedCanvas.toDataURL("image/png");
    //     const pdf = new jsPDF({
    //         orientation: "landscape",
    //         unit: "px",
    //         format: [combinedCanvas.width, combinedCanvas.height],
    //     });
    //     pdf.addImage(dataURL, "JPEG", 0, 0);
    //     pdf.save(!configName ? 'site_plan.pdf' : `${configName}.pdf`);
    // };

    const getMousePosition = (e) => {
        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport
        // Position of the mouse click on Canvas
        const mouseX = (e.clientX - rect.x);
        const mouseY = (e.clientY - rect.y);        
        return {mouseX, mouseY}
    };

        // Handle mouse click on canvas. Check if mouse click is on the dropped camera's position
    const handleOnMouseDown = (e) => {
        const {mouseX,mouseY} = getMousePosition(e); // position of the mouse click
        
        draggingSiteMapRef.current = true;
        lastMouse.current = { x: e.clientX, y: e.clientY }; // save where mouse went down

        // Convert mouse position from screen space to world space
        const worldMouseX = (mouseX - pan.x) / zoom;
        const worldMouseY = (mouseY - pan.y) / zoom;

        for (const placedCamera of cameraPositions) {
            // Check if the mouse click is on the current camera
            if (worldMouseX >= placedCamera.x && worldMouseX <= placedCamera.x+camImageWidth &&
                worldMouseY >= placedCamera.y && worldMouseY <= placedCamera.y+camImageHeight) {
                    draggingRef.current = placedCamera.camera_id; // reference to currently clicked camera
                    setIsHovering(false);
                    draggingSiteMapRef.current = false;
            }
        }        
    };

    // Allows dragging camera icon around Canvas and update the camera position given the mouse is currently on the camera
    const handleOnMouseMove = async(e) => {
        const {mouseX,mouseY} = getMousePosition(e); // position of the mouse move on Canvas

        setIsHovering(false);
        hoveringCamImg.current = null;

        // Check if mouse cursor is on the camera, set isHovering = true and capture the camera_id.
        if (draggingSiteMapRef.current) {
            if (zoom === 1) return; // don't let user drag the plan when zoom = 1
            if (pan.x > 0 || pan.y > 0) return;
            const dx = e.clientX - lastMouse.current.x;
            const dy = e.clientY - lastMouse.current.y;

            const canvas = canvasRef.current;
            const zoomedWidth = canvas.width * zoom;
            const zoomedHeight = canvas.height * zoom;
          
            const minX = canvas.width - zoomedWidth;
            const minY = canvas.height - zoomedHeight;
            const maxX = 0;
            const maxY = 0;
          
            setPan((prev) => ({
              x: Math.min(maxX, Math.max(minX, prev.x + dx)),
              y: Math.min(maxY, Math.max(minY, prev.y + dy)),
            }));
            lastMouse.current = { x: e.clientX, y: e.clientY };
        }
        else {
             // Convert mouse position from screen space to world space
            const worldMouseX = (mouseX - pan.x) / zoom;
            const worldMouseY = (mouseY - pan.y) / zoom;

            setIsHovering(false);
            hoveringCamImg.current = null;
            // Hovering on camera icons
            for (const placedCamera of cameraPositions) { 
                // Check if the mouse cursor is on the current camera
                if (worldMouseX >= placedCamera.x && worldMouseX <= placedCamera.x+camImageWidth &&
                    worldMouseY >= placedCamera.y && worldMouseY <= placedCamera.y+camImageHeight) {
                        hoveringCamImg.current = placedCamera.camera_id;
                        setIsHovering(true);
                }
            }
        }
    };

    // Handle mouseup
    const stopDragging = async(e) => {
        draggingRef.current = null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Leave any bounding boxes
    const stopHovering = () => {
        draggingRef.current = null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Retrieve position of the mouse relative to canvas
    const getTouchPosition = (e) => {
        const touch = e.touches[0];
        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport
        
        // Need to scale the coordinates of touch since it's smaller(touch) screen
        const scaleX = canvas.width/rect.width; // 800/CssWidth
        const scaleY = canvas.height/rect.height; // 600/CssWidth

        const touchX = (touch.clientX - rect.x) * scaleX;
        const touchY = (touch.clientY - rect.y) * scaleY;

        return {touchX, touchY}
    };

     // For touch event
    const handleOnTouchStart = (e) => {
         if (draggingRef.current) {        
                return;
        }  

        const touch = e.touches[0];
        const {touchX, touchY} = getTouchPosition(e);
        // Convert touch position from screen space to world space
        const worldTouchX = touchX;
        const worldTouchY = touchY;
        
        draggingSiteMapRef.current = true;
        lastMouse.current = { x: touch.clientX, y: touch.clientY };

        for (const placedCamera of cameraPositions) { 
            // Check if the mouse click is on the current camera
            if (worldTouchX >= placedCamera.x && worldTouchX <= placedCamera.x+camImageWidth &&
                worldTouchY >= placedCamera.y && worldTouchY <= placedCamera.y+camImageHeight) {
                    draggingRef.current = placedCamera.camera_id; // reference to currently clicked camera
                    
                    setIsHovering(false);
                    draggingSiteMapRef.current = false;

                    const newImageUrl = placedCamera.monthly_image_url;
                    const newCameraName = placedCamera.camera_name;
                    if (selectedImageUrl !== newImageUrl || selectedCameraName !== newCameraName) {
                            setSelectedImageUrl(newImageUrl);
                            setSelectedCameraName(newCameraName);
                            setSelectedImageUpdateTime(placedCamera.monthly_image_update_time || null);
                    }
                    setShowModal(true);
                    break;
            }                
        }       
    };

    // For touch to move event
    const handleOnTouchMove = async(e) => {
          setShowModal(false);
        // e.preventDefault(); // prevent page scroll/zoom when moving 
        // const canvas = canvasRef.current;
        const touch = e.touches[0];
        const {touchX,touchY} = getTouchPosition(e); // position of the mouse move on Canvas
        
        // Check if mouse cursor is on the camera, set isHovering = true and capture the camera_id.
        if (draggingSiteMapRef.current) {
            if (zoom === 1) return; // don't let user drag the plan when zoom = 1
            if (pan.x > 0 || pan.y > 0) return;
            const dx = touch.clientX - lastMouse.current.x;
            const dy = touch.clientY - lastMouse.current.y;

            const canvas = canvasRef.current;
            const zoomedWidth = canvas.width * zoom;
            const zoomedHeight = canvas.height * zoom;
            
            const minX = canvas.width - zoomedWidth;
            const minY = canvas.height - zoomedHeight;
            const maxX = 0;
            const maxY = 0;
            
            setPan((prev) => ({
                x: Math.min(maxX, Math.max(minX, prev.x + dx)),
                y: Math.min(maxY, Math.max(minY, prev.y + dy)),
            }));
            lastMouse.current = { x: touch.clientX, y: touch.clientY };
        } 
        // Check if touch cursor is on the camera, set isHovering = true and capture the camera_id. 
        else {
            setIsHovering(false);
            hoveringCamImg.current = null;

            const worldTouchX = (touchX - pan.x) / zoom;
            const worldTouchY = (touchY - pan.y) / zoom;

            // Hovering on camera icons
            for (const placedCamera of cameraPositions) { 
                // Check if the touch cursor is on the current camera
                if (worldTouchX >= placedCamera.x && worldTouchX <= placedCamera.x+camImageWidth &&
                    worldTouchY >= placedCamera.y && worldTouchY <= placedCamera.y+camImageHeight) {
                        hoveringCamImg.current = placedCamera.camera_id;
                        setIsHovering(true);
                }
            }
        }
    };

    // Untouch
    const stopDraggingTouch = async(e) => {
        draggingRef.current=null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Handle Zoom In +
    const handleZoomIn = () => {
        const canvas = canvasRef.current;
        const newZoom = Math.min(zoom + ZOOM_STEP, MAX_ZOOM); // increase scale by 100%
        setZoom(newZoom); // scale up by 100%, otherwise 400% if exceeding
        
        const centerX = canvas.width/2 - 20; // Leave 40centerX for delete zone
        const centerY = canvas.height/2;

        const worldX = (centerX-pan.x)/zoom;
        const worldY = (centerY-pan.y)/zoom;

        const newPan = {
            x: centerX - worldX * newZoom,
            y: centerY - worldY * newZoom
        }

        setPan(newPan);
    };

    // Handle Zoom Out -
    const handleZoomOut = () => {
        const canvas = canvasRef.current;
        const newZoom = Math.max(zoom - ZOOM_STEP, MIN_ZOOM); // decrease scale by 100%
        setZoom(newZoom); // scale down by 100%, otherwise 100% when < 100%        

        // If zooming out to MIN_ZOOM, reset everything
        if (newZoom <= MIN_ZOOM){
            setZoom(1);
            setPan({x:0, y:0});
            return;
        }
        
        const centerX = canvas.width/2 - 20; // Leave 40centerX for delete zone
        const centerY = canvas.height/2;

        const worldX = (centerX-pan.x)/zoom;
        const worldY = (centerY-pan.y)/zoom;

        const newPan = {
            x: Math.min(centerX - worldX * newZoom, 0),
            y: Math.min(centerY - worldY * newZoom, 0)
        }
        setPan(newPan);
    };

    const handleUndoZoomPan = () => {
        setZoom(1);
        setPan({x:0, y:0});
    };
    
    return (
        <div className="save-config-container">
            <div className="progress-steps">
                <div className="step completed">
                    <div className="step-number">1</div>
                    <span>Upload Site Plan</span>
                </div>
                <div className="step completed">
                    <div className="step-number">2</div>
                    <span>Place Cameras</span>
                </div>
                <div className="step active">
                    <div className="step-number">3</div>
                    <span>Save Configuration</span>
                </div>
            </div>

            <div className="camera-siteplan-container">
                {/* Camera list  */}
                <div className="camera-list-buttons-container">
                    <p className="camera-header">Available Cameras</p>
                    <div className="total-cameras-and-search-box-container">
                        <div className="search-camera-container">
                            <i className="fas fa-search"></i>
                            <input
                            className="search-camera-box"
                            type="text"
                            value={searchItem}
                            onChange={handleSearchItem}
                            placeholder="Search Camera..."
                            />
                            {searchItem && (
                            <span
                                className="clear-icon-camera"
                                onClick={() => handleClearSearch()}
                            >
                                &times; {/* This is the "X" icon */}
                            </span>
                            )}
                        </div>
                    </div>

                    {/* Legends */}
                    <div className="legend">
                        <div className="legend-title">
                            Legend
                        </div>
                        <div className="legend-items">
                            <div className="legend-cam-placed">
                                <div className="legend-item-placed">
                                    <img src={onlCamImg} alt="cam-img" className="cam-img-legend"></img>
                                    Placed
                                </div>
                                <div className="legend-item-placed">
                                    <img src={unplacedCamImg} alt="cam-img" className="cam-img-legend"></img>
                                    Unplaced
                                </div>
                            </div>

                            <div className="legend-cam-status">
                                <div className="legend-item-status">
                                    <div className="legend-dot" style={{background: '#1cfd51'}}></div>
                                    Online Camera
                                </div>
                                <div className="legend-item-status">
                                    <div className="legend-dot" style={{background: '#bb201e'}}></div>
                                    Offline Camera
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="stats-container">
                        <div className="stat">
                            <div className="total-cam" style={{color: 'white', fontWeight: 'bold'}}>{totalCameras}</div>
                            <div className="stat-title">Total</div>
                        </div>
                        <div className="stat">
                            <div className="total-cam" style={{color: 'rgb(28, 253, 81)'}}>{totalOnlineCams}</div>
                            <div className="stat-title">Online</div>
                        </div>
                        <div className="stat">
                            <div className="total-cam" style={{color: 'rgb(187, 32, 30)'}}>{totalCameras-totalOnlineCams}</div>
                            <div className="stat-title">Offline</div>
                        </div>
                        <div className="stat" style={{border:"none"}}>
                            <div className="total-cam" style={{color: '#7b8185'}}>{totalCameras - totalPlacedCams}</div>
                            <div className="stat-title">Unplaced</div>
                        </div>
                    </div>

                    <hr></hr>

                    <div className="camera-list-container">
                        {
                        totalCameras > 0 ?
                            filteredCameraList?.map((cameraObj, index) => (
                                <Cameras
                                key={index}
                                cameraObj={cameraObj}
                                index={index}
                                placedCamera={cameraPositions.find((camera) => (camera.camera_id === cameraObj.camera_id))}
                                />
                            ))
                        :
                            <p className="no-camera-avail"> No cameras available </p>
                        }
                    </div>
                </div>

                {/* Site Plan */}
                <div className="siteplan-overall-container">
                    {/* Site Plan layer */}
                    <div className="siteplan-container">
                        {/* Computer view */}
                        {!isSmallScreen ? 
                        <>
                            <canvas
                                ref={canvasRef}
                                width={800}
                                height={600}
                                // style={{border: '1px solid #e08a20', position: 'absolute'}}
                                style={{ position: 'absolute'}}
                            >
                            </canvas>

                            {/* Camera Icons layer  */}
                            <canvas
                                onClick={handleCanvasClick}
                                onMouseDown={handleOnMouseDown}
                                onMouseUp={stopDragging}
                                onMouseMove={handleOnMouseMove}
                                onMouseLeave={stopHovering}
                                ref={(node) => {
                                    canvascamImagesRef.current=node;
                                }}
                                width={800}
                                height={600}
                                style={{position: 'absolute'}}
                            >
                            </canvas>
                        </>
                        :
                        // Mobile view
                        <>
                            <canvas
                                ref={canvasRef}
                                width={800}
                                height={600}
                                style={{ position: 'absolute'}}
                                className="canvas-siteplan-small"
                            >
                            </canvas>

                            {/* Camera Icons layer  */}
                            <canvas 
                                onTouchStart={handleOnTouchStart}
                                onTouchMove={handleOnTouchMove}
                                onTouchEnd={stopDraggingTouch}
                                ref={(node) => {
                                    canvascamImagesRef.current=node;
                                }}
                                width={800}
                                height={600}
                                style={{position: 'absolute'}}
                                className="canvas-siteplan-small"
                            >
                            </canvas>                          

                        </>
                        }
                    </div>
                    <div className="zoom-container">
                        <Tooltip content='Zoom in' placement='top'>
                            <button onClick={handleZoomIn}><i className="fa-solid fa-plus"></i></button>
                        </Tooltip>
                        <Tooltip content='Zoom out' placement='top'>
                            <button onClick={handleZoomOut}><i className="fa-solid fa-minus"></i></button>
                        </Tooltip>
                        <Tooltip content='Reset' placement='top'>
                            <button onClick={handleUndoZoomPan}><i className="fas fa-undo"></i></button>
                        </Tooltip>
                    </div>

                    {/* Modal to show camera image */}
                    <Modal
                        show={showModal}
                        onHide={closeModal}
                        position="center"
                        size="md"
                        >
                        <Modal.Header>
                            <Modal.Title>
                                <div>{selectedCameraName}</div>
                                { 
                                    getDatePart(selectedImageUpdateTime) && (
                                        <div className="image-update-time">
                                            <span>Last update: </span>
                                            {getDatePart(selectedImageUpdateTime)}
                                            <span> | Monthly shanpshot</span>
                                        </div>
                                    )
                                }

                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body
                            // className="modal-color"
                            style={{
                                height: imageLoaded ? "auto" : "300px", // Reserve space
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {selectedImageUrl ? (
                                <div
                                    style={{
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <img
                                        src={selectedImageUrl}
                                        alt="Camera Preview"
                                        onLoad={handleImageLoad}
                                            style={{
                                            width: "100%",
                                            height: "100%", // 👈 Stretch to container height
                                            objectFit: "cover", // 👈 Keep image ratio nicely
                                            filter: animate ? "blur(0px)" : "blur(20px)",
                                            opacity: animate ? 1 : 0.7,
                                            transition: "filter 0.8s ease, opacity 0.8s ease",
                                        }}
                                    />
                                   
                                </div>
                            ) : (
                                <NoImageAvailable />
                            )}
                        </Modal.Body>                                
                    </Modal>
                </div>
                
                <div className = "config-details-container">
                    <p className="camera-header">Configuration Details</p>
                    <p className="text-header">Review and save your camera setup</p>
                    
                    {/* Config name */}
                    <div className="config-content">
                        <div className="form-section">
                            <h4 className="section-title">
                                <span>📝</span>
                                Configuration Name
                            </h4>
                            <div className="form-group-export">
                                <Input 
                                    label="Configuration Name"
                                    type="text" 
                                    value={configName} 
                                    placeholder="Enter configuration name" 
                                    onChange={handleConfigNameChange}
                                />
                            </div>
                        </div>

                        {/* Export Options */}
                        <div className="form-section">
                            <h4 className="section-title">
                                <span>💾</span>
                                Export Options
                            </h4>
                            <div className="export-options">
                                <p className="export-title">Download configuration as:</p>
                                <div className="export-buttons">
                                    {/* <button className="export-btn" onClick={handleExportAsPDF}>
                                        <span>📄</span>
                                        PDF
                                    </button> */}
                                    <button className="export-btn" onClick={handleExportAsPNG}>
                                        <span>🖼️</span>
                                        Image
                                    </button>
                                </div>
                            </div>
                        </div>

                        {!isSmallScreen &&
                        <div className="tip-content">
                            <div className="guidelines-title">Reposition Cameras:</div>
                            Click <strong>Back</strong> to go to the <strong>Place Cameras</strong> step where you can adjust camera positions.
                        </div>
                        // :
                        // <p onClick={() => setOpenGuidelinePopUp(true)} className="view-guideline-btn">View Guidelines</p>
                        }
                    </div>

                    {/* Save configuration */}
                    <div className="save-config-buttons">
                        <button className="reset-pos-button" 
                                onClick={handleGoToCameraPlacement} 
                                disabled = {!canAccess("site-map-update", userBusinessRole)}><i className="fa-solid fa-caret-left"></i> Back
                        </button>
                        {/* <button className="save-button" onClick={handleSaveLayout} disabled={(cameraPositions.length>0?false:true)}>Save Configuration</button> */}
                        <Button style={{fontSize: '1.1'}} onClick={handleSaveLayout} disabled={(cameraPositions.length === 0 || !canAccess("site-map-update", userBusinessRole))}>Save Configuration</Button>
                    </div>

                    {/* Tips */}
                    {isSmallScreen &&
                    <div className="tip-container">
                        <div className="guidelines-title">Reposition Cameras:</div>
                        Click 'Back' to return to the 'Place Cameras' step and add or adjust your camera positions.
                    </div>
                    }
                </div>
            </div>

            {/* Modal to show guidelines
            <Modal show={openGuidelinePopUp} onHide={() => setOpenGuidelinePopUp(false)}>
                <Modal.Header closeButton className='delete-modal-header'>
                    <Modal.Title>
                    <span className='delete-modal-title'>
                        Guidelines
                    </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='delete-modal-body'>
                    <div className="tip-content">
                        <div className="guidelines-title">Reposition Cameras:</div>
                        Click 'Back' to return to the 'Place Cameras' step and add or adjust your camera positions.
                    </div>
                </Modal.Body>           
            </Modal> */}
    
        </div>
    );
}

export default SaveConfig;